import { IContactOverview } from './contact.i';

export class CContactOverview implements IContactOverview {
  id = 0;
  nom = '';
  prenom?: string;
  mail?: string;
  tel?: string;

  constructor(source?: IContactOverview) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        nom: source.nom,
        prenom: source.prenom,
        mail: source.mail,
        tel: source.tel
      });
    }
  }
}
